import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import pluralize from 'pluralize';

import { getAsset } from '../../../../util/assets';
import Badge from '../../Badge';
import PriceDisplay from '../../PriceDisplay';
import PrintPackageItemsList from '../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/components/AlbumPrintPackageOption/PrintPackageItemsList';
import { DIGITAL_DOWNLOADS_MODE } from '../../../../constants/print-packages';
import CheckoutItemQuantityInput from '../../../../services/checkout/components/CheckoutCartItem/CheckoutItemQuantityInput';
import { getPrintOrderServiceLabels } from '../../../../util/print-order-configuration';

const propTypes = {
  className: PropTypes.string,
  albumPrintPackage: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  cartItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onAlbumPrintPackageToggle: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  identity: PropTypes.shape({
    id: PropTypes.string,
  }),
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const AlbumPrintPackageOption = ({
  className,
  albumPrintPackage,
  cartItem,
  onAlbumPrintPackageToggle,
  onUpdate,
}) => {
  const classes = classNames({
    [className]: !!className,
    'purchasing-option-item': true,
    'purchasing-option-item-album-print-package': true,
    'is-selected': !!cartItem,
  });

  const printPackage = albumPrintPackage.print_package;
  const orderServiceLabels = getPrintOrderServiceLabels(
    printPackage.print_order_configuration,
  );

  const thumbClasses = classNames({
    'purchasing-option-item-thumb': true,
    'thumb-image-fill': !!printPackage?.preview_asset_image?.url,
  });

  return (
    <div className={classes}>
      <div className={thumbClasses}>
        <img
          src={
            printPackage?.preview_asset_image?.url ??
            getAsset('/icon-package-3d.svg')
          }
          alt=""
        />
      </div>

      <div className="purchasing-option-item-content-wrap">
        <div className="purchasing-option-item-title">
          <div className="text-truncate">{printPackage.name}</div>
          <div className="purchasing-option-item-info-extra">
            <Badge badgeStyle="yellow" className="text-extra-bold">
              <PriceDisplay
                price={printPackage.price.value}
                currency={printPackage.price.currency}
              />
            </Badge>
          </div>
        </div>

        <div className="purchasing-option-item-content">
          {printPackage.max_checkout_items && (
            <p className="text-sm lh-normal text-dark text-bold">
              Choose any{' '}
              {pluralize('product', printPackage.max_checkout_items, true)} from
              the following when configuring:
            </p>
          )}
          <PrintPackageItemsList albumPrintPackage={albumPrintPackage} />

          {printPackage.digital_downloads_mode ===
            DIGITAL_DOWNLOADS_MODE.INCLUDED && (
            <span className="d-block text-sm text-italic text-bold">
              Includes hi&ndash;res download for this photo
            </span>
          )}
          {orderServiceLabels.length > 0 && (
            <span className="d-block text-sm text-italic text-bold">
              Includes {orderServiceLabels.join(', ')}
            </span>
          )}
        </div>

        <div className="purchasing-option-item-actions">
          <CheckoutItemQuantityInput
            min={0}
            onChange={value => {
              if ((!cartItem && value > 0) || (!!cartItem && value === 0)) {
                // Either no cart item in cart or removing cart item.
                onAlbumPrintPackageToggle();
                return;
              }

              // Else, update the quantity.
              onUpdate(cartItem.id, {
                quantity: value,
              });
            }}
            value={cartItem?.quantity || 0}
            label=""
          />
        </div>
      </div>
    </div>
  );
};

AlbumPrintPackageOption.propTypes = propTypes;

export default AlbumPrintPackageOption;
